import moment from "moment";
import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { TooltipProps } from "recharts";
import {
	ValueType,
	NameType,
} from "recharts/types/component/DefaultTooltipContent";
import { Dispatch } from "redux";
import insightSelectors from "redux/app/insight/selectors";
import { generateArrowedString } from "redux/app/insight/utils";
import { IStore } from "redux/store";

type OwnProps = {};

const CustomTooltip = (
	props: TooltipProps<ValueType, NameType> & OwnProps & PropsFromRedux
) => {
	const { active, payload, label, noonReportMetricsList } = props;

	if (active && payload && payload.length) {
		return (
			<div className="bg-white p-2.5 border-[0.5px] font-redhat-text rounded-md shadow-md">
				<p className="label font-redhat-text ">{`${moment(
					label,
					"DD-MM-YYYY"
				).format("Do MMM")}`}</p>

				{payload.map((category: any) => {
					const metricItem = noonReportMetricsList.byIds[category?.dataKey];
					return (
						<div key={category?.dataKey} className="flex items-center text-sm">
							<div
								className="w-2 h-2 rounded-full mr-1"
								style={{ background: category.stroke }}
							/>
							<p className="text-[12px] text-gray-600">
								{category?.dataKey
									? category?.dataKey in noonReportMetricsList.byIds
										? generateArrowedString([
												metricItem?.sectionTitle ?? "",
												metricItem?.subSectionTitle ?? "",
												metricItem?.metricTitle ?? "",
										  ])
										: ""
									: ""}{" "}
								:{" "}
								{"payload" in category &&
								isNaN(category["payload"][category?.dataKey])
									? "NA"
									: (category["payload"][category?.dataKey] as number)?.toFixed(
											2
									  )}
							</p>
						</div>
					);
				})}
			</div>
		);
	}

	return null;
};

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const insightStore = insightSelectors._getStore(store);
	const noonReportMetricsList =
		insightSelectors.getNoonReportMetricsList(insightStore);
	return {
		noonReportMetricsList,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;

export default reduxConnector(CustomTooltip);
